<template lang="html">

  <section class="destacados pad-sec slider" v-if="!!noticiasProcessed">
    <div class="container">
      <h2 class="title title-36">{{$t("blog.noticias_relacionadas")}}</h2>
      <div class="contenedor" v-if="!!noticias">
        <vue-slick-carousel 
            class="contenedorslider noticias-destacadas"
            
            v-bind="slickOptions"
          >
            <noticia-el v-for="(e, key) in noticiasProcessed" :data="e" :key="key"></noticia-el>
        </vue-slick-carousel>
      </div>
      <!--<div class="flex wrap justify-between">
               <template v-if="!!noticias">
            <noticia-el v-for="(e, key) in noticiasProcessed" :data="e" :key="key"></noticia-el>
          </template> 
      </div>-->
    </div>
    <router-link class="btn btn-dark btn-center" v-if="!small" :to="$t('enlaces.blog')" target="_blank">{{$t('actualidad.noticias.ir_blog')}}</router-link>
  </section>

</template>

<script lang="js">
  import VueSlickCarousel from 'vue-slick-carousel';

  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios' 

  Vue.use(VueAxios, axios);

  import Noticia_el from '@/components/parts/noticia-el';

  import { mapGetters } from 'vuex'


  export default  {
    name: 'noticias-relacionadas',
    props: ['small','cat', 'titulo'],
    mounted() {

      axios.get(`blog/${this.cat}?lang=${this.lang}`)
      .then(response => {
        this.noticias = response.data.noticias;
      })
      .catch(error => console.log(error));
    },
    data() {
      return {
        noticias: '',
        slickOptions: {
          slidesToShow: 3,
          arrows: true,
          responsive: [
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2
              }
            },
            {
              breakpoint: 800,
              settings: {
                centerMode: true,
                slidesToShow: 1,
                slidesToScroll: 1,
              
              }
            }
          ]
        },
      }
    },
    computed: {
      noticiasProcessed : function (){

        let noticias;

        if(this.noticias){
          let count = this.noticias.length;
          let actual = this.$route.params.id;
          let noticiasToFilter = this.noticias.slice(0,count);
          noticias = noticiasToFilter.filter(n => n.titulo != this.titulo);
        }

        return noticias;

      },
      ...mapGetters({
        lang: 'getLanguage',
      }),

    },
    components: {
      'noticia-el': Noticia_el,
      'vue-slick-carousel': VueSlickCarousel,
    }
  }
</script>

<style scoped>
.slick-slide .art-dest {
  max-width: 90% !important;
}
.contenedor {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
}

.contenedor .contenedorslider {
  width: 95%;
  
}

</style>



// WEBPACK FOOTER //
// src/components/view-parts/ficha-blog/noticias-relacionadas.vue